import { AccessTime, Cancel, CheckCircle, DeliveryDining, SoupKitchen } from "@mui/icons-material"

export const ORDER_TYPE = {
  LOCAL: 'Consumir no Local',
  PICK_UP: 'Retirar no Local',
  DELIVERY: 'Entrega'
}

export const ORDER_ORIGIN = {
  local: 'Salão',
  delivery: 'Delivery'
}

export const ORDER_STATUS_MAP = {
  NEW_ORDER: 'Aguardando Confirmação',
  PREPARING: 'Em Preparação',
  DELIVERING: 'Em Transporte',
  CANCELED: 'Cancelado',
  COMPLETED: 'Finalizado'
}

export const ORDER_STATUS = {
  'Aguardando Confirmação': { icon: <AccessTime />, color: "#f8c046ff" },
  'Em Preparação': { icon: <SoupKitchen />, color: "#00d00eff" },
  'Em Transporte': { icon: <DeliveryDining />, color: "#00d00eff" },
  'Cancelado': { icon: <Cancel />, color: "red" },
  'Finalizado': { icon: <CheckCircle />, color: "#00d00eff" }
}

export const PAYMENT_METHODS = [
  { key: 'PIX', label: 'PIX' },
  { key: 'DINHEIRO', label: 'Dinheiro' },
  { key: 'CARTAO DE CREDITO', label: 'Cartão de Crédito' },
  { key: 'CARTAO DE DEBITO', label: 'Cartão de Débito' }
]

export const ITEMS = [
  {
    "name": "CERVEJA AMSTEL LATAO",
    "price": 7.5
  },
  {
    "name": "PORCAO",
    "price": 50
  },
  {
    "name": "CAIPIRINHA",
    "price": 10
  }
]